const range = (a, b) => Array.from({ length: b - a + 1 }, (_, i) => a + i);
const PREFIXES = {
  MTN: new Set([...range(650, 654), ...range(670, 683)]),
  ORANGE: new Set([...range(655, 659), ...range(686, 699)]),
};

export const operatorOf = (raw) => {
  let d = (raw || "").replace(/[\s\-.()+]/g, "");
  if (d.startsWith("00237")) d = d.slice(2);
  if (d.length === 12 && d.startsWith("237")) d = d.slice(3);
  if (!/^6\d{8}$/.test(d)) return null;
  const p = +d.slice(0, 3);
  return Object.keys(PREFIXES).find((op) => PREFIXES[op].has(p)) || "unknown";
};

export const localPhone = (raw) => (raw || "").replace(/^237(?=6\d{8}$)/, "");

export const useMomoPhone = (user, setUser) => {
  const remember = (phone) => setUser((u) => (u ? { ...u, momo_phone: phone } : u));
  return [localPhone(user?.momo_phone || user?.phone), remember];
};
